(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  function sizeCartLogo() {
    var logo = document.querySelector('.template-cart .site-header__logo-image img');
    if (!logo) return;

    var sourceSet = logo.getAttribute('data-srcset');
    var sourceTemplate = logo.getAttribute('data-src');
    var widths = logo.getAttribute('data-widths');

    if (sourceSet) {
      logo.setAttribute('srcset', sourceSet);
    } else if (sourceTemplate && widths && sourceTemplate.indexOf('{width}') !== -1) {
      var parsedWidths = JSON.parse(widths);
      var generatedSourceSet = parsedWidths.map(function (width) {
        return sourceTemplate.replace('{width}', width) + ' ' + width + 'w';
      }).join(', ');

      logo.setAttribute('src', sourceTemplate.replace('{width}', 540));
      logo.setAttribute('srcset', generatedSourceSet);
    }

    logo.removeAttribute('data-sizes');
    logo.setAttribute('sizes', '(max-width: 650px) 80vw, 520px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sizeCartLogo);
  } else {
    sizeCartLogo();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dtc-home"] && !Shopify.designMode) return;
  try {
    
  function sizeHomepageLogo() {
    var logo = document.querySelector('.template-index .site-header__logo-image img');
    if (!logo) return;

    var sourceSet = logo.getAttribute('data-srcset');
    var sourceTemplate = logo.getAttribute('data-src');
    var widths = logo.getAttribute('data-widths');

    if (sourceSet) {
      logo.setAttribute('srcset', sourceSet);
    } else if (sourceTemplate && widths && sourceTemplate.indexOf('{width}') !== -1) {
      var parsedWidths = JSON.parse(widths);
      var generatedSourceSet = parsedWidths.map(function (width) {
        return sourceTemplate.replace('{width}', width) + ' ' + width + 'w';
      }).join(', ');

      logo.setAttribute('src', sourceTemplate.replace('{width}', 540));
      logo.setAttribute('srcset', generatedSourceSet);
    }

    logo.removeAttribute('data-sizes');
    logo.setAttribute('sizes', '(max-width: 650px) 80vw, 520px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sizeHomepageLogo);
  } else {
    sizeHomepageLogo();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-dtc-city-picker]');
    if (!form) return;

    event.preventDefault();
    var city = form.querySelector('[data-dtc-city]');
    if (city && city.value) {
      window.location.assign(city.value);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
